import qs from 'query-string';

import appSettings from 'wanderu-config';
import {
    selectLocale,
} from 'wanderu-i18n';
import Logger from 'wanderu-logger';
import { SnowplowService } from 'wanderu-service-analytics';
import { TixService } from 'wanderu-service-wapi';

import {
    actions as bookingActions,
    selectors as bookingSelectors,
} from '../../appstate';
import {
    actions,
    namespace,
    reducer,
    selectors,
} from './base';

const logger = Logger.getLogger('wanderu-app-booking:fetchTripConfirmation');

function fetchTripConfirmation(tripId) {
    return async (dispatch, getState) => {
        dispatch(actions.startWork(tripId));

        let error;
        let meta;
        try {
            const locale = selectLocale(getState());
            const {
                itineraryId,
                bookingSessionId,
            } = bookingSelectors.selectBookingInfo(getState());
            const processingId = bookingSelectors.selectProcessingId(getState(), tripId);
            const queries = {
                locale,
                processing_ids: processingId,
                itinerary_id: itineraryId,
                booking_session_id: bookingSessionId,
            };

            const response = await TixService.get(`v3/book/confirmation?${qs.stringify(queries)}`);

            return dispatch(bookingActions.setTripConfirmation(tripId, response.result.orders[0]));
        } catch (ex) {
            const domainUserInfo = appSettings.env.isClient
                ? SnowplowService.getDomainUserInfo()
                : {};

            logger.error('fetch', ex, {
                snowplowIds: {
                    networkUserId: SnowplowService.getNetworkUserId(),
                    ...domainUserInfo,
                },
            });

            error = {
                code: ex.code,
                message: ex.message,
                name: ex.name,
            };

            throw ex;
        } finally {
            dispatch(actions.endWork(tripId, meta, error));
        }
    };
}

function reset(opts) {
    return actions.reset(opts);
}

const fetchTripConfirmationAction = {
    fetch: fetchTripConfirmation,
    reset,
    ...selectors,
};

export {
    fetchTripConfirmationAction,
};

export default {
    [namespace]: reducer,
};
